import { MessageCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BookingForm } from "@/components/BookingForm";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLanguage } from "@/i18n";
import { waLink } from "@/whatsapp";

export default function BookingPage() {
  const { t } = useLanguage();

  return (
    <div className="bg-obsidian min-h-screen">
      <Navbar />
      <main className="pt-36 pb-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal>
            <Eyebrow>ATLAS PROPERTY INTELLIGENCE</Eyebrow>
            <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-ivory">{t.form.title}</h1>
            <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{t.form.sub}</p>
          </Reveal>

          <Reveal delay={0.1} className="mt-10">
            <div
              data-testid="booking-whatsapp-banner"
              className="bg-midnight border border-gold/40 rounded-lg p-7 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-6 shadow-[0_0_30px_rgba(212,175,55,0.1)]"
            >
              <div className="flex-1">
                <p className="font-serif text-2xl font-semibold text-ivory">{t.wa.note}</p>
                <p className="mt-2 font-mono text-xl tracking-[0.12em] text-gold" data-testid="booking-phone-number">
                  {t.wa.number}
                </p>
                <p className="mt-2 text-xs text-slate-500">{t.wa.availability}</p>
              </div>
              <a
                href={waLink(t.wa.msgVisit)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="booking-whatsapp-cta"
                className="inline-flex items-center justify-center gap-3 bg-gold text-obsidian font-bold text-sm tracking-[0.08em] px-8 py-4 rounded-full hover:bg-gold-light transition-colors duration-300 shrink-0"
              >
                <MessageCircle className="w-5 h-5" />
                {t.wa.cta}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.2} className="mt-10">
            <BookingForm />
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
}
